import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useCart } from "@/lib/cart";
import { toast } from "sonner";
import { ShoppingBag } from "@phosphor-icons/react";

export default function Shop() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const { add } = useCart();

  useEffect(() => { api.get("/merch").then((r) => setItems(r.data)); }, []);

  const categories = useMemo(() => ["all", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const visible = filter === "all" ? items : items.filter((i) => i.category === filter);

  const addItem = (i) => {
    add({ item_id: i.id, name: i.name, price: i.price, image: i.image, type: "merch" });
    toast.success(`Added ${i.name} to cart`);
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="shop-page">
      <div className="section-eyebrow">Drop One</div>
      <h1 className="font-display text-5xl lg:text-7xl uppercase mt-3">Shop</h1>
      <p className="text-dim mt-3 max-w-xl">Official SCU apparel, collectibles, and gear. Wear the crown.</p>

      <div className="mt-8 flex flex-wrap gap-2" data-testid="shop-filters">
        {categories.map((c) => (
          <button
            key={c}
            onClick={() => setFilter(c)}
            data-testid={`filter-${c}`}
            className={`px-4 py-2 font-display text-xs tracking-widest uppercase border ${filter === c ? "bg-[#FF3B30] text-black border-[#FF3B30]" : "border-white/20 text-white hover:border-[#FF3B30]"}`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="shop-grid">
        {visible.map((i) => (
          <article key={i.id} className="scu-card group" data-testid={`shop-item-${i.id}`}>
            <div className="aspect-[4/5] overflow-hidden bg-black">
              <img src={i.image} alt={i.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <div className="text-xs uppercase tracking-widest text-dim">{i.category}</div>
              <div className="font-display text-xl uppercase mt-1">{i.name}</div>
              <p className="text-dim text-sm mt-2">{i.description}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="font-display text-2xl text-[#FF3B30]">${i.price?.toFixed(2)}</span>
                <button onClick={() => addItem(i)} className="btn-red inline-flex items-center gap-2" data-testid={`add-to-cart-${i.id}`}>
                  <ShoppingBag size={16} weight="bold" /> Add
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
